
import api from 'Common/Client/Interceptor'


const courseEnrollmentsReportService = {
  getReport: async (params) => {
    const response = await api.get(`/indv/reports/courses/enrollments`, {
      params,
    })
    return response
  },

  downloadReport: async (params) => {
    const response = await api.get(`/indv/reports/courses/enrollments/download`, {
      params,
      responseType: 'blob',
    })
    return response
  },
}

export default courseEnrollmentsReportService